import { Component, Input, ViewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Modal, ModalOption } from '../../../models/modal';
import { TranslationService } from '../../../services/translation.service';
import { ActionElementComponent } from '../../../base/action-element';
import { NgComponentOutlet, NgClass, NgStyle } from '@angular/common';
import { SafePipe } from '../../../pipes/safe.pipe';
import { StylePipe } from '../../../pipes/style.pipe';
import { ClassPipe } from '../../../pipes/class.pipe';
import { PortalErrorEvent } from '../../../models/portal-error-event';

@Component({
    selector: 'app-modal-default',
    templateUrl: './modal-default.component.html',
    styleUrls: ['./modal-default.component.scss'],
    imports: [
        FormsModule,
        NgComponentOutlet,
        NgClass,
        NgStyle,
        SafePipe,
        StylePipe,
        ClassPipe,
    ],
})
export class ModalDefaultComponent extends ActionElementComponent {
  @ViewChild('ngForm') ngForm: NgForm | null = null;
  parent!: EventTarget;
  modalAction: Modal | null = null;
  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private translation: TranslationService
  ) {
    super();
    this.onClose = new Subject();
  }

  override action($event: any, option: ModalOption): void {
    $event.stopPropagation();
    $event.preventDefault();
    if (this.modalAction && this.modalAction.form && option.submit) {
      if (this.ngForm && this.ngForm.valid) {
        if (option.pageRequests && option.pageRequests.length) {
          for (const pageRequest of option.pageRequests) {
            if (pageRequest.option) {
              pageRequest.option['form'] = this.ngForm.value;
            } else {
              pageRequest.option = {
                form: this.ngForm.value,
              };
            }
          }
        }
        super.fireActionEvent(this.parent, option);
        this.bsModalRef?.hide();
      } else {
        // Dispatch error event to be handled by parent (avoiding circular dependency with modal service)
        window.dispatchEvent(
          new CustomEvent(PortalErrorEvent.EVENT_NAME, {
            bubbles: true,
            detail: new PortalErrorEvent({} as any, this.translation.getTranslation('REQUIRED_FIELD_MISSING'))
          })
        );
      }
    } else {
      super.fireActionEvent(this.parent, option);
      this.bsModalRef?.hide();
    }
  }
}
